import { upsertHolidaySchedule } from '../graphql/mutations';
import { getHolidayScheduleStatus } from '../graphql/queries';
import { makeApiAction } from './actions';

/**
 * Note: passing restId as a param since this happens on load and we might not have chosen restId in storage yet
 */
export const fetchHolidayScheduleAction =
  (restId, startDate = '2026-01-26', endDate = '2026-02-01') =>
  (dispatch) => {
    const action = 'FETCH_HOLIDAY_SCHEDULE';
    const data = {
      restId,
      startDate,
      endDate,
    };

    dispatch(makeApiAction(action, getHolidayScheduleStatus, data, {}, 'getHolidayScheduleStatus'));
  };

export const updateHolidayScheduleAction = (surcharge, days) => (dispatch) => {
  const action = 'UPDATE_HOLIDAY_SCHEDULE';
  const data = {
    surcharge,
    days,
  };

  dispatch(
    makeApiAction(
      action,
      upsertHolidaySchedule,
      data,
      data,
      'upsertHolidaySchedule',
      true,
      null,
      'Your holiday hours have been updated',
    ),
  );
};
